import Vue from "vue";

Vue.directive("onlyNumber", {
  bind(el, binding, vnode) {
    el.addEventListener("input", () => {
      el.value = el.value.replace(/[^0-9]/g, "");
    });
  }
});

Vue.directive("validate", {
  bind(el, binding, vnode) {
    const regx =
      /[^a-zA-Z0-9ㄱ-ㅎㅏ-ㅣ가-힇]([ㆍᆢ]).,\/\-\_\( \)\#\~\;\&\<\>\@]/;
    el.addEventListener("input", (e) => {
      el.value = el.value.replace(regx, "");
    });
    el.addEventListener("focusout", (e) => {
      el.value = el.value.replace(regx, "");
    });
  }
});

Vue.directive("focus", {
  inserted(el) {
    el.focus();
  }
});
